import React, { useState } from "react";

import DocSearchContextWrapper from "./context/doc-search-context-wrapper";
import OrgSearchContextWrapper from "./context/org-search-context-wrapper";
import {
  SearchResultsAccordionCollapsedContext,
  SearchTabContext,
} from "./context/search-context";
import UserSearchContextWrapper from "./context/user-search-context-wrapper";
import GrsSearchContextWrapper from "context/grs-search-context-wrapper";
import IdentitySearchContextWrapper from "context/identity-search-context-wrapper";
import TemplateSearchContextWrapper from "context/template-search-context-wrapper";

interface AppRouterContextProps {
  children: React.ReactNode;
}

const AppRouterSearchContext = ({ children }: AppRouterContextProps) => {
  const [searchTab, setSearchTab] = useState(0);
  const [docSearchKey, setDocSearchKey] = useState(0);
  const [userSearchKey, setUserSearchKey] = useState(0);
  const [orgSearchKey, setOrgSearchKey] = useState(0);

  const getInitialSearchResultsAccordionCollapsed = () => {
    const data = window.localStorage.getItem("ACCORDION_COLLAPSED");
    return data !== null ? JSON.parse(data) : {};
  };
  const [searchResultsAccordionCollapsed, setSearchResultsAccordionCollapsed] =
    useState(getInitialSearchResultsAccordionCollapsed);

  const searchTabsContextValue = {
    searchTab,
    setSearchTab,
    docSearchKey,
    setDocSearchKey,
    userSearchKey,
    setUserSearchKey,
    orgSearchKey,
    setOrgSearchKey,
  };
  const searchResultsAccordionCollapsedContextValue = {
    searchResultsAccordionCollapsed,
    setSearchResultsAccordionCollapsed,
  };

  return (
    <>
      <SearchTabContext.Provider value={searchTabsContextValue}>
        <SearchResultsAccordionCollapsedContext.Provider
          value={searchResultsAccordionCollapsedContextValue}
        >
          <UserSearchContextWrapper>
            <IdentitySearchContextWrapper>
              <OrgSearchContextWrapper>
                <TemplateSearchContextWrapper>
                  <GrsSearchContextWrapper>
                    <DocSearchContextWrapper>
                      {children}
                    </DocSearchContextWrapper>
                  </GrsSearchContextWrapper>
                </TemplateSearchContextWrapper>
              </OrgSearchContextWrapper>
            </IdentitySearchContextWrapper>
          </UserSearchContextWrapper>
        </SearchResultsAccordionCollapsedContext.Provider>
      </SearchTabContext.Provider>
    </>
  );
};

export default AppRouterSearchContext;
